import scope from "./scope";
import { SummaryType } from "@ls/grouping-service";
import SelectionState from "state/selections/SelectionState";
import { fetchSecurityAttributes } from "@ls/grouping-service";
import { selectGetGroupingParams } from "state/selections/selectors";
import { exchange } from "@ls/js-fetch";
import { selectDefinitions } from "./selectors";

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});
export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});
export const REQUEST_SECURITY_ATTRIBUTE_OPTIONS = `${scope}/REQUEST_SECURITY_ATTRIBUTE_OPTIONS`;
export const RECEIVE_SECURITY_ATTRIBUTE_OPTIONS = `${scope}/RECEIVE_SECURITY_ATTRIBUTE_OPTIONS`;
export const requestSecurityAttributeOptions = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SECURITY_ATTRIBUTE_OPTIONS });
    const options = Object.values((await fetchSecurityAttributes()) || {});
    dispatch({
      type: RECEIVE_SECURITY_ATTRIBUTE_OPTIONS,
      data: [...options, "repSecId"],
    });
  };
};

export const REQUEST_SECURITY_ATTRIBUTES_DATA = `${scope}/REQUEST_SECURITY_ATTRIBUTES_DATA`;
export const RECEIVE_SECURITY_ATTRIBUTES_DATA = `${scope}/RECEIVE_SECURITY_ATTRIBUTES_DATA`;
export const requestGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    if (!definitions?.length) {
      return;
    }

    dispatch({ type: REQUEST_SECURITY_ATTRIBUTES_DATA });
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(
      state,
    );
    // Always include cusip to ensure API returns security data (needed for synthetic attributes like repSecId)
    const apiAttributes = [
      "cusip",
      ...definitions.map(({ attribute }) => attribute),
    ];
    const params = getGroupingParams({
      summary: SummaryType.RELATIVE,
      benchesToo: true,
      results: ["SECURITY_ATTRIBUTES"],
      security_attributes: [...new Set(apiAttributes)],
      meta_data: "ALL",
    });
    dispatch({
      type: RECEIVE_SECURITY_ATTRIBUTES_DATA,
      data: (
        await exchange({
          params,
          url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
          cancelId: `security-attributes-data`,
        })
      )?.data,
    });
  };
};
